var map = {
	"./cov-01-faq-desktop.png": 3871,
	"./cov-02-faq-desktop.png": 3872,
	"./cov-03-faq-desktop.png": 3873,
	"./cov-04-faq-desktop.png": 3874,
	"./cov-05-faq-desktop.png": 3875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5494;